// Frequently asked questions (FAQ page; the first few `featured` ones also appear on the home page).
export const faqCategories = [
  { id: "admission", name: "Admission" },
  { id: "treatment", name: "Treatment" },
  { id: "family", name: "Family & Visiting" },
  { id: "payment", name: "Payment" },
];

const faqs = [
  {
    id: 1,
    category: "admission",
    featured: true,
    q: "How do I admit a patient?",
    a: "Call our 24/7 number or fill in the admission enquiry form. Our duty psychiatrist assesses the patient first and then recommends outpatient care or admission. Please bring previous prescriptions and a photo ID of the guardian.",
  },
  {
    id: 2,
    category: "admission",
    featured: false,
    q: "What if the patient does not want to come for treatment?",
    a: "This is common, especially with addiction. Our team can guide the family on how to approach the patient safely and, where clinically and legally appropriate, help with admission involving the family.",
  },
  {
    id: 3,
    category: "treatment",
    featured: true,
    q: "How long does addiction treatment take?",
    a: "Detox usually takes 7–14 days. A complete rehabilitation programme usually runs 30–90 days depending on the substance, the duration of use and the patient's progress.",
  },
  {
    id: 4,
    category: "treatment",
    featured: true,
    q: "Is my treatment kept confidential?",
    a: "Yes. All consultations and treatment records are strictly confidential and are shared only with the clinical team and family members the patient agrees to.",
  },
  {
    id: 5,
    category: "treatment",
    featured: false,
    q: "Do you have separate units for male and female patients?",
    a: "Yes. We have separate and secure units for male and female patients, with female staff for the female unit.",
  },
  {
    id: 6,
    category: "family",
    featured: false,
    q: "Can family members visit?",
    a: "Yes, on scheduled visiting days. Visiting may be limited during the first days of detox for the patient's wellbeing. Family counseling sessions are also part of the programme.",
  },
  {
    id: 7,
    category: "family",
    featured: false,
    q: "Can I bring food or personal items?",
    a: "Outside food and some items are restricted for safety. Please check with the nursing station before bringing anything.",
  },
  {
    id: 8,
    category: "payment",
    featured: true,
    q: "How is payment made for admission?",
    a: "A minimum 15 days' payment is required at admission and further payments are made fortnightly in advance. Medicines and tests are charged at actual cost. All dues must be cleared before discharge.",
  },
  {
    id: 9,
    category: "payment",
    featured: false,
    q: "Do you accept mobile banking?",
    a: "Please contact our reception for the current payment methods.",
  },
];

export const faqContent = {
  title: "Frequently Asked Questions",
  subtitle: "Answers to the questions families ask us most.",
  contactPrompt: "Still have a question?",
};

export default faqs;
